<template>
  <div>
    <div>
      <el-steps :active="$route.meta.active" finish-status="success" simple>
        <el-step v-for="item in stepList" :key="item" :title="item"></el-step>
      </el-steps>
    </div>
    <router-view />
  </div>
</template>

<script >
	import _constant from '@/utils/constant'
  export default {
    data(){
      return {

      }
    },
    computed:{
      // 获取步骤条数据
      stepList(){
        let list=[]
        for(let key in _constant.routeStepMap){
          if(key==this.$route.meta.key){
            list=_constant.routeStepMap[key]
          }
        }
        return list
      }
    },
    methods:{

    }
  }
</script>

<style scoped>

</style>